<template>
    <div>
        <div class="">
            <div class="contenedor-busquedaFuncionario">
                <select class="js-example-basic-single text-center" id="listaFuncionarios">
                    <option>Cargando...</option>
                </select>
                <button style="height:100%;  width:4rem; justify-content: center;" @click="seleccionFuncionario" class="btn btn-vino btn-lupa"><i class="fas fa-search icono-lupa"></i></button>
            
            </div>
                <p style="" id="error" class="d-none errorEstilos">*Debe ingresar el nombre de un funcionario</p> <!---mensaje de error para cuando no se seleccione ningun funcionario--->
            <!-- ===============Area de visualización de los datos del funcionario seleccionado=========================== -->
            <div v-if="verDatos">
                <div v-show="!loading">
                    <spiner></spiner>
                    <h6 class="text-center text-muted text-cargando"> Cargando contenido...</h6>
                </div>
                <div v-show="loading"> <!----Aqui va la condición del spiner-------->
                    <div v-for="(datos, x) in data" :key="x">
                        <div v-for="(datos_padre, y) in datos" :key="y">
                            <!----Si el arreglo organos_padre solo tiene un objeto es porque un hijo directo de hacienda (funcionario nivel2)---->
                            <div v-if="datos_padre.organos_padre.length === 1"> 
                                <div class="datos-n2">
                                    <!-- Aqui van los funcionarios nivel 2 -->
                                    <p class="titulo-n2">Datos del funcionario seleccionado:</p>
                                    <div class="lineaNegra"></div>
                                    <div class="mt-1 mb-2 lineaNegra2"></div>
                                    <!-- Datos del funcionario n2 -->
                                    <p style="color: #560f2c; font-size: 18px;">{{datos_padre.funcionario_seleccionado.Organo}}</p>
                                    <p style="font-weight:bolder;">{{datos_padre.funcionario_seleccionado.Funcionario}}</p>
                                    <p>{{datos_padre.funcionario_seleccionado.conmutador}}</p>
                                    <p>{{datos_padre.funcionario_seleccionado.Correo}}</p>
                                    <p>{{datos_padre.funcionario_seleccionado.domicilio}} {{datos_padre.funcionario_seleccionado.colonia}} C.P. {{datos_padre.funcionario_seleccionado.cp}} {{datos_padre.funcionario_seleccionado.municipio}} </p>

                                    
                                    <div>
                                        <h1 class="OrganoTitulo">Direcciones que pertenecen a este Órgano Administrativo:</h1> <!-- Barra guinda -->
                                    </div>
                                    <!-- Zona de collapses con las direcciones del organo -->
                                    <!-- <div v-for="(hijo, z) in datos_padre.organos_hijo" :key="z">                                 -->
                                        <div class="container my-4">
                                            <div class="accordion mt-4" id="accordionExample">
                                                <div v-for="(hijo, z) in datos_padre.organos_hijo" :key="z">
                                                    <div class="card card-padre">
                                                        <div class="card-header" :id="'heading'+z" style="/*background: #f0f0f0;*/">
                                                            <h2 class="mb-0">
                                                                <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" :data-target="'#collapse'+z+1" aria-expanded="true" :aria-controls="'collapse'+z+1" style="display:flex; justify-content:space-between;">
                                                                <span>{{hijo.Organo}}</span> <!--nombre de la dirección ó organo hijo--->
                                                                <span class="descargar" style="font-size:1.5rem;"><i class='bx bx-chevron-down icono-down' style="color: #560f2c;"></i></span>
                                                                </button>
                                                            </h2>
                                                        </div>
                                                        <div :id="'collapse'+z+1" class="collapse" :aria-labelledby="'heading'+z" data-parent="#accordionExample">
                                                            <div class="card-body">
                                                                <!-- Demas datos de la dirección (hijos) -->
                                                                <p> <b>{{hijo.Funcionario}}</b></p>
                                                                <p> {{hijo.conmutador}} - {{hijo.Correo}} </p>
                                                                <p> {{hijo.domicilio}} {{hijo.colonia}} C.P. {{hijo.cp}} {{hijo.municipio}} </p>                        

                                                                <div style="width:100%; border-bottom: .1rem dashed #ce232345; margin-top: .8rem;"></div>
                                                                <div class="cards-estilos">                                                                    
                                                                    <div v-for="(nieto, l) in hijo" :key="l">
                                                                        <div v-if="nieto && hijo.IDOrgano === nieto.IDPadre"> <!----Hay que poner esta condición ya que sin ella no reconoce ninguno de los datos del objeto **nieto**---->
                                                                            <div class="card text-dark cards-st" style="max-width: 17.5rem;">
                                                                                <div class="card-header  bg-light">{{nieto.Organo}}</div>
                                                                                <div class="card-body estilos-p" >    
                                                                                    <p>{{nieto.Funcionario}}</p>
                                                                                    <p>{{nieto.domicilio}} {{nieto.colonia}} C.P. {{nieto.cp}} {{nieto.municipio}}, Chiapas</p>
                                                                                    <p>{{nieto.conmutador}}</p>
                                                                                    <p>{{nieto.Correo}}</p>
                                                                                </div>
                                                                            </div>                                                                                                                           
                                                                        </div>                                    
                                                                    </div>
                                                                </div>                                                      
                                                            </div>
                                                        </div>                                                            
                                                    </div> 

                                                </div>
                                            </div>
                                        </div>              
                                    <!-- </div> -->
                                </div>
                            </div>
                            <!----Si tiene más de un elemento es porque puede ser un funcionario nivel 3 o 4------> 
                            <div v-else>                           
                                <div v-for="(organo_admin, i) in datos_padre.organos_padre" :key="i"> <!--Ciclo solo para obtener el organo admin--------->
                                    <div v-if="organo_admin.IDPadre === 43 "> <!---Condición que me permite obtener el hijo directo de hacienda (organo admin)---->                               
                                        <p class="titulo-organo">{{organo_admin.Organo}}</p>
                                        <!-- Si el organo administrativo tiene funcionario poner todos sus datos -->                        
                                            <div v-if='organo_admin.Funcionario === "" || organo_admin.Funcionario === " "'>
                                                <!-- <p>NO HAY FUNCIONARIO</p> -->
                                            </div>
                                            <div v-else>
                                                <!-- <p>HAY FUNCIONARIO</p>  -->
                                                <div class="datos-funcionarioN2">
                                                    <p style="color: #560f2c; font-size: 18px;">{{organo_admin.Funcionario}}</p>                                    
                                                    <p>{{organo_admin.conmutador}}</p>
                                                    <p>{{organo_admin.Correo}}</p>
                                                    <p>{{organo_admin.domicilio}} {{organo_admin.colonia}} C.P. {{organo_admin.cp}} {{organo_admin.municipio}}</p>
                                                </div>                                    
                                            </div>                                            
                                    </div>                                
                                </div>
                                <!-- ======A PARTIR DE AQUI VALIDACIONES PARA IDENTIFICAR UN FUNCIONARIO NIVEL 2 O 3===== -->

                                <!-- =====Si un funcionario no tiene ningun elemento en el arreglo de hijos Y en su arreglo de padres tiene 3
                                elementos es porque es un funcionario **nivel 4** =====-->
                                <div v-if="datos_padre.organos_hijo.length === 0 && datos_padre.organos_padre.length === 3 ">
                                    <!-- Ciclo para obtener el papá de los funcionarios nivel 4 (direcciones) -->
                                    <div v-for="(direccion, d) in datos_padre.organos_padre" :key="d">
                                        <div v-if="direccion.IDOrgano != 43 && direccion.IDPadre != 43">
                                            <!-- Datos del padre de los funcionarios nivel 4 -->
                                            <div class="datos-n3">
                                                <p style="color: #560f2c; font-size: 18px;">{{direccion.Organo}}</p>
                                                <p style="font-weight:bolder;">{{direccion.Funcionario}}</p>
                                                <p>{{direccion.conmutador}}</p>
                                                <p>{{direccion.Correo}}</p>
                                                <p>{{direccion.domicilio}} {{direccion.colonia}} C.P. {{direccion.cp}} {{direccion.municipio}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Datos del funcionario nivel 4 -->
                                    <div class="datos-n4">
                                        <p class="titulo-n3-n4">Datos del funcionario seleccionado:</p>
                                        <div class="lineaNegra"></div>
                                        <div class="mt-1 mb-2 lineaNegra2"></div>
                                        <p style="color: #560f2c; font-size: 18px; line-height: 22px;">{{datos_padre.funcionario_seleccionado.Organo}}</p>
                                        <p style="font-weight:bolder;">{{datos_padre.funcionario_seleccionado.Funcionario}}</p>
                                        <p>{{datos_padre.funcionario_seleccionado.conmutador}}</p>
                                        <p>{{datos_padre.funcionario_seleccionado.Correo}}</p>
                                        <p>{{datos_padre.funcionario_seleccionado.domicilio}} {{datos_padre.funcionario_seleccionado.colonia}} C.P. {{datos_padre.funcionario_seleccionado.cp}} {{datos_padre.funcionario_seleccionado.municipio}} </p>

                                    </div>
                                </div>

                                <!--=====De lo contrario es un funcionario **nivel 3**======---->
                                <div v-else>
                                    <!-- Datos funcionarios n3 -->
                                    <div class="datos-n2">
                                        <!-- Datos del funcionario n3 -->
                                        <p class="titulo-n3-n4">Datos del funcionario seleccionado:</p>
                                        <div class="lineaNegra"></div>
                                        <div class="mt-1 mb-2 lineaNegra2"></div>
                                        <p style="color: #560f2c; font-size: 18px; line-height: 22px">{{datos_padre.funcionario_seleccionado.Organo}}</p>
                                        <p style="font-weight:bolder;">{{datos_padre.funcionario_seleccionado.Funcionario}}</p>
                                        <p>{{datos_padre.funcionario_seleccionado.conmutador}}</p>
                                        <p>{{datos_padre.funcionario_seleccionado.Correo}}</p>
                                        <p>{{datos_padre.funcionario_seleccionado.domicilio}} {{datos_padre.funcionario_seleccionado.colonia}} C.P. {{datos_padre.funcionario_seleccionado.cp}} {{datos_padre.funcionario_seleccionado.municipio}} </p>

                                        <!-- Cards con los departamentos de cada funcionario n3 -->
                                        <div v-if="datos_padre.organos_hijo.length != 0"> <!----Si el funcionario tiene hijos imprimir la barrita guinda------->
                                            <h1 class="OrganoTitulo">Departamentos adscritos:</h1>
                                        </div>
                                        <div class="cards-estilos">
                                            <div v-for="(departamento, a) in datos_padre.organos_hijo" :key="a">
                                                <div v-if="departamento"> <!----Hay que poner esta condición ya que sin ella no reconoce ninguno de los datos del objeto **nieto**---->
                                                    <div class="card text-dark cards-st" style="max-width: 17.5rem;">
                                                        <div class="card-header  bg-light text-center" style="font-weight: 400;">{{departamento.Organo}}</div>
                                                        <div class="card-body estilos-p" >    
                                                            <p>{{departamento.Funcionario}}</p>
                                                            <p>{{departamento.domicilio}} {{departamento.colonia}} C.P. {{departamento.cp}} {{departamento.municipio}}, Chiapas</p>
                                                            <p>{{departamento.conmutador}}</p>
                                                            <p>{{departamento.Correo}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                                               
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>               
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import axios from "axios"
import spiner from "../../spiner.vue"
export default {
    name: 'DirectorioBusquedaFuncionario',
    components:{
        spiner
    },
    data:function(){
        return{            
            listadoFuncionario: 'https://api.chiapas.gob.mx/funcionarios/lista/nombres/43', //servicio montado en la nube

            //=======json´s montado en el servidor de github============
            //listadoFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/lista_funcionarios.json', 

            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/julioC_Egresos_n2.json',
            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/ramiro_Planeacion_n2.json',

            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/odilio_n3.json',
            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/dulceJeanette_n3.json',
            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/juanCAlejo_n3.json',
            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/robertoIsaac_n3.json',
            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/mariaLuisa_n3.json',
            
            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/tomasGustavo_n4.json',
            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/mauriciaEvangelina_n4.json',
            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/adriano_n4.json',
            //jsonFuncionario: 'https://amairanibarsanas.github.io/servicios_retys/ivonne_n4.json',

            dataFuncionario: null,
            //variable para la busqueda de funcionarios
            funcionarioSeleccionado: '',
            verDatos: false,
            data: [],
            //variable del spiner
            loading: false,
        }
    },
    created:function() {
        this.consultaFuncionarios();
    },
    methods:{
        llenadoSelectFuncionarios(idSelect){
            var listaFun = this.dataFuncionario
            // console.log("hola desde el metodo llenadoSelect", listaOrganosHijo, idSelect, this.loading);
            $("#"+idSelect).empty();
            $("#"+idSelect).append("<option hidden selected></option>");
            $.each(listaFun, function (indice, row) {  
                if (row != 'Dr. Javier Jiménez Jiménez')//Para que no imprima el nombre del secretario de hacienda en la lista del select2
                 {                    
                    $("#" + idSelect).append("<option value='" + row + "'>" + row + "</option>");     
                    // console.log(row);         
                }
            });
            $("#" + idSelect).select2({ 
                    placeholder: "Ingrese el nombre del funcionario",
                });            
        },
        consultaFuncionarios(){
            axios
            .get(this.listadoFuncionario)
            .then((res) =>{
                this.dataFuncionario = res.data;
                this.llenadoSelectFuncionarios('listaFuncionarios');
            })
        },
        seleccionFuncionario(){            
            var urlBusqueda = 'https://api.chiapas.gob.mx/funcionarios/nombre/' //url para consulta por nombre
            this.funcionarioSeleccionado = document.getElementById('listaFuncionarios').value; //nombre obtenido del select2
            var idHacienda = 43 

            if (this.funcionarioSeleccionado == '') { //Si el usuario no selecciona ningun funcionario mostrar el mensaje de error
               console.log("No hay funcionario");
               document.getElementById('error').className = 'd-block errorEstilos';
            } else{ // de lo contrario ejecutar la consulta de la información del funcionario seleccionado
                this.verDatos = true; 
                var urlConsultaFuncionario = urlBusqueda+this.funcionarioSeleccionado+'/'+idHacienda //url completa para la consulta de los datos del funcionario seleccionado

                axios
                .get(urlConsultaFuncionario)
                //.get(this.jsonFuncionario) //descomentar para hacer pruebas con los json´s de los funcionarios
                .then((res)=>{
                    this.data.push(res.data) //= res.data  /// LA RESPUESTA ERA UN ARRAY LO CAMBIARON A UN OBJETO
                    this.loading = true
                })
                document.getElementById('error').className = 'd-none errorEstilos';
            }
        }
    },
    watch:{
        funcionarioSeleccionado: function(){ //cada vez que cambie el funcionario seleccionado, cambiar el loading a falso para que el spiner se active cada vez que se busque el nuevo funcionario
            this.loading = false; 
        },
    }
}
</script>

<style scoped>
.contenedor-busquedaFuncionario{
    display: flex;
    justify-content: center;
    height: 2.5rem; /**aqui alto select2** */
    width: 90%;
    /* margin-bottom: 2rem; */
}

 #listaFuncionarios{
    border: 1px solid #d3cfcf;
    width: 47rem; /**47rem aqui ancho select2** */
    border-radius: 0.25rem;
    padding-left: .3rem;
    color: darkgray;
    font-size: 20px;
} 

.btn-lupa {
    height: 1.78rem;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    display: flex;
    align-items: center;
}
.errorEstilos{
        color:#b11a1a;
        margin-bottom:0;
        font-size: 13px;
        text-align: center;
    }

/* Estilos de funcionarios nivel 2 */
.datos-n2 p, .datos-n3 p, .datos-n4 p, .datos-funcionarioN2 p {
    margin-bottom: 0;
}
.datos-funcionarioN2{
    margin-bottom: 0.8rem;
}
.datos-n4{
    margin-top: 0.8rem;
}
.titulo-n2{
    font-size: 1.6rem;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 1.5rem;
}
/* Estilos de los collapses */
.OrganoTitulo{ /****Barra guinda** */
    font-size: 1.5rem;
    font-weight: 300;
    color:#fff;
    background: #702544de;
    padding: 1rem;
    border-bottom-right-radius: 22px;
    margin-top: 1rem;
}

.card-header { background-color: #fff;}
.btn-link{ 
    color: #560f2c;
    font-size: 18px;
    letter-spacing: .3px;
}
.btn:focus { box-shadow: none; }
.btn-link:hover { text-decoration: none; }

.btn{ padding: 0 !important;}

.cards-estilos{
    display: flex;
    flex-wrap: wrap;
}
.cards-st{ 
    margin: 1rem;
    max-width: 18rem;
    min-height: 20rem;    
 }
.card-padre{
    border: 1px solid #fff ;
    border-bottom: 1px solid #cbcbcb78 !important;
    border-radius: 0 !important;
    margin-top: 1.5rem;
    
}    

.descargar{
    font-size: 0.9rem;
    color: #6c757d !important;
}


a{
    text-decoration: none !important;
    color: #212529;
}
a:hover{ color:#212529 !important; }
    
.card-width{ width: 90%; }
.card-body p{margin-bottom: 0.1rem !important; /***aqui */}
.estilos-p{ font-size: 14px; }

/***Estilod funcionarios nivel 3 y 4*** */
.titulo-organo{
    font-size: 1.6rem;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 1rem;
}
.titulo-n3-n4{
   font-size: 1.3rem;
   font-weight: 500;
   margin-bottom: 0; 
}

/* ESTILOS PARA MOVILES */
@media only screen and (max-device-width : 900px){
    .titulo-organo{
        line-height: 26px;
        margin-top: 1.3rem;
    }
    /* Zona de collapses y cards (busqueda por organos) */
    .cards-estilos{
        /* justify-content: center; */
        display: flex;
        justify-content: space-around;
    }
    .margenes{ justify-content: space-around !important; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }

    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }

        .cards-st{
        margin: .5rem 0;
        
        width: 17rem;
        height: 21rem; 
    }

    /* Busqueda por funcionarios */
    #listaFuncionarios{
        width: 300px!important;
    }
    .contenedor-busquedaFuncionario{
        width: 100%;
        margin-bottom: 0.5rem;
    }
    .titulo-n2{
        line-height: 25px;
        margin-top: 1.5rem;
        margin-bottom: 0.3rem !important;
    }

    .titulo-n3-n4[data-v-3e604d00] {
        line-height: 25px;
        margin-bottom: 0.3rem !important;
    
    }




    /* diseño de los collapses */
    .OrganoTitulo { /**barra guinda* */
        font-size: 1.35rem;
    }

}


</style>